import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { Placement } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, from, Subscription, take } from 'rxjs';
import { RowContextMenu } from '../models';

@UntilDestroy()
@Directive({
  selector: '[mbsContextMenu]',
  exportAs: 'contextMenuRef'
})
export class ContextMenuDirective {
  @Input() mbsContextMenu: RowContextMenu;
  @Input('contextMenuPlacement') placement: Placement | Array<Placement> | string;
  @Output() openedContextMenu = new EventEmitter<{ event: MouseEvent; data: any }>();
  @Output() closedContextMenu = new EventEmitter<void>();

  private closedSubscription: Subscription;

  open(event: MouseEvent, data: any) {
    event.preventDefault();

    const context = this.mbsContextMenu;
    if (!context?.elementRef || !context?.ngbDropdown) return;

    const { elementRef, ngbDropdown } = context;
    const { x, y } = event;

    (ngbDropdown as any).data = data;

    Object.assign(elementRef.style, {
      left: `${x}px`,
      top: `${y}px`,
      position: 'fixed'
    });

    ngbDropdown.display = 'dynamic';
    ngbDropdown.autoClose = true;
    ngbDropdown.placement = context.placement || this.placement || 'bottom-left bottom-right top-left top-right';

    this.closedSubscription?.unsubscribe();
    this.closedSubscription = from(ngbDropdown.openChange)
      .pipe(
        filter((isOpen: boolean) => !isOpen),
        take(1),
        untilDestroyed(this)
      )
      .subscribe(() => this.closedContextMenu.emit());

    ngbDropdown.open();
    this.openedContextMenu.emit({ event, data });
  }
}
